// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604281334/js/" + chunkId + "." + {"44":"9140ab86","225":"59510446","481":"909658ba","486":"b52a5df6","770":"09eecf8e"}[chunkId] + ".0.43633780128668187.chunk.js";
};